import { Link, NavLink } from "react-router-dom";
import React, { useState } from "react";
import logo from "../header/oktobizLogo.png";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import {
  FiLogOut,
  FiHome,
  FiBriefcase,
} from "react-icons/fi";

//import sidebar css from react-pro-sidebar module and our custom css
import "react-pro-sidebar/dist/css/styles.css";
import "./Sidebar.css";
import { useNavigate } from 'react-router-dom';

const SideBar = () => {
  const navigate = useNavigate();
  const [menuCollapse] = useState(false);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  let role = sessionStorage.getItem('bb_role');

  return (
    <>
      <div id="header" style={{ position: "absolute", width: "304px" }}>
        <ProSidebar collapsed={menuCollapse}>
          <SidebarHeader className="sidebar-header">
            <div className="logotext">
              <Link to="/home">
                <img src={logo} alt="oktobiz_logo" />
              </Link>
            </div>
          </SidebarHeader>
          <SidebarContent>
            <Menu iconShape="square">
              {role === 'admin' ? (
                <MenuItem icon={<FiHome />}>
                  <NavLink
                    to="/home"
                    className={({ isActive }) => (isActive ? "menu-link active-link" : "menu-link")}
                  >
                    Dashboard
                  </NavLink>
                </MenuItem>
              ) : null}
              <MenuItem icon={<FiBriefcase />}>
                <NavLink
                  to="/table"
                  className={({ isActive }) => (isActive ? "menu-link active-link" : "menu-link")}
                >
                  Registered Business
                </NavLink>
              </MenuItem>
            </Menu>
          </SidebarContent>
          <SidebarFooter>
            <Menu iconShape="square">
              <MenuItem icon={<FiLogOut />} onClick={handleLogout}>
                Logout
              </MenuItem>
            </Menu>
          </SidebarFooter>
        </ProSidebar>
      </div>
    </>
  );
};

export default SideBar;
